mainApp.directive('iframeAutomaticDimensions', [function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            element.on('load', function() {
                element.css('width', '100%');
                element.css('height', element[0].contentWindow.document.body.scrollHeight + 'px');
            });
        }
    }
}]);